import(/* webpackMode: "eager" */ "/codebuild/output/src2515120848/src/faunaexplore-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2515120848/src/faunaexplore-frontend/public/static/images/hero-bg.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["HomeCarouselsClient"] */ "/codebuild/output/src2515120848/src/faunaexplore-frontend/src/app/page/HomeCarouselsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafariCountriesSection"] */ "/codebuild/output/src2515120848/src/faunaexplore-frontend/src/components/safari-countries/SafariCountriesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TravelWithConfidenceCarousel"] */ "/codebuild/output/src2515120848/src/faunaexplore-frontend/src/components/travel-with-confidence/TravelWithConfidenceCarousel.tsx");
